import React, { useEffect, useState } from "react";
import LoadingComp from "../LoadingComp";
import Utils from "../../utils/utils";
import { CiUser } from "react-icons/ci";
import { TbCalendarTime } from "react-icons/tb";
import { IoIosCheckmarkCircleOutline } from "react-icons/io";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import axios from "axios";
import { useToast } from "../ToastContext";
import SubmissionCard from "./SubmissionCard";
import QuestionList from "./QuestionList";
import AssessedToggle from "./AssessedToggle";

const AssignmentDetails = ({ props }) => {
  const { item } = props;
  const token = Utils.getToken();
  const SERVER_URL = `${process.env.REACT_APP_SERVER_URL}`;
  const [submissions, setSubmissions] = useState([]);
  const showToast = useToast();
  const [loading, setLoading] = useState(true);
  const [showQuestions, setShowQuestions] = useState(false);
  const [showDueDates, setShowDueDates] = useState(false);
  const [assessed, setAssessed] = useState("not_assessed"); // 'assessed' or 'not_assessed'

  const [assignment, setAssignment] = useState(
    JSON.parse(JSON.stringify(item))
  );

  const FetchSubmissions = async (assignmentId, assessed) => {
    const query = { assessed };
    try {
      const response = await axios.get(
        `${SERVER_URL}/assignments/submissions/${assignmentId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          params: query,
        }
      );

      if (response.status === 200) {
        const res = response.data;
        setSubmissions((prev) => res);
        setLoading(false);
        // const arr = res.answers;
        // const answersObject = Object.fromEntries(
        //   arr.map((item) => [item._id, item.answer])
        // );
        //   setUpdatedAns((prev) => answersObject);
        //   setSubmissions((prev) => res.answers);
      } else {
        setLoading(false);
        // showToast(response.statusText, "warning", true, 300);
      }
    } catch (error) {
      setLoading(false);
      showToast(error.message, "error", true, 3000);
    }
  };

  useEffect(() => {
    const flag = assessed === "not_assessed" ? false : true;
    FetchSubmissions(item._id, flag);
  }, [assessed]);

  return (
    <div>
      <div
        bkl="AssignmentDetails"
        className="min-h-full h-full overflow-x-hidden overflow-y-auto bg-white p-4 rounded-l-lg"
        style={{
          WebkitOverflowScrolling: "touch", // For smooth scrolling on iOS
          scrollbarWidth: "none", // Firefox
          msOverflowStyle: "none", // IE and Edge
        }}
      >
        <div className="p-6 space-y-4 min-h-fit shadow rounded mb-4">
          <div className="bg-gray-50 p-3 mt-2">
            <h3 className="text-2xl font-semibold text-gray-700 truncate">
              {assignment.title}
            </h3>
          </div>

          <p className="text-gray-600 text-md">
            <span className="font-medium">Description : </span>
            {assignment.description}
          </p>

          <div className="flex gap-4">
            <div
              className="flex items-center gap-1"
              key={"InstructorName" + item._id}
            >
              <div
                className={`h-6 w-6 text-sm rounded-full flex items-center justify-center overflow-hidden ${
                  assignment.instructorName
                    ? Utils.getRandomBgColor() + " text-white"
                    : ""
                }`}
              >
                {assignment.instructorName ? (
                  Utils.getUserAvatar(assignment.instructorName)
                ) : (
                  <CiUser className="w-5 h-5" />
                )}
              </div>
              <div className="font-normal text-md text-[#544D4F]">
                {assignment.instructorName}
              </div>
            </div>
          </div>

          {assignment.remarks && (
            <p className="text-gray-500 text-md italic">
              Remarks : {assignment.remarks}
            </p>
          )}
          <div className="mt-4">
            {assignment.all ? (
              <span className="inline-flex items-center gap-1 rounded-full bg-pink-100 px-3 py-1 text-xs font-medium text-pink-700">
                All Batches
                <IoIosCheckmarkCircleOutline className="w-5 h-5 font-extrabold" />
              </span>
            ) : (
              <div className="flex flex-wrap gap-2">
                {assignment.batch.map((batch) => (
                  <span
                    key={batch}
                    className="rounded-full bg-gray-100 px-3 py-1 text-xs font-medium text-gray-600"
                  >
                    {batch}
                  </span>
                ))}
              </div>
            )}
          </div>

          <div className="mt-4">
            <button
              onClick={() => setShowDueDates(!showDueDates)}
              className="inline-flex items-center gap-2 text-sm font-medium text-gray-700 hover:text-gray-900"
            >
              Due Dates
              {showDueDates ? (
                <FaChevronUp className="mt-1" />
              ) : (
                <FaChevronDown className="mt-1" />
              )}
            </button>
            {showDueDates && (
              <div className="animate-show  flex flex-wrap gap-2 mt-2">
                {Object.entries(item.dueDates).map(([batch, date]) => (
                  <div
                    key={batch}
                    className="card w-60 bg-white shadow-md border border-gray-200 rounded-lg hover:shadow-lg transition-shadow"
                  >
                    <button className="inline-flex items-center gap-2 rounded-lg bg-red-50 px-3 py-1.5 text-sm font-medium">
                      <span className="text-red-600">{batch}</span>
                      <span className="text-gray-600">
                        {Utils.formatDateTime(date)}
                      </span>
                    </button>
                  </div>
                ))}
              </div>
            )}
          </div>

          <div className="mt-4">
            <div className="flex justify-between">
              <button
                onClick={() => setShowQuestions(!showQuestions)}
                className="inline-flex items-center gap-2 text-sm font-medium text-gray-700 hover:text-gray-900"
              >
                Questions
                {showQuestions ? (
                  <FaChevronUp className="mt-1" />
                ) : (
                  <FaChevronDown className="mt-1" />
                )}
              </button>
              <button
                disabled
                className="inline-flex  items-center gap-2 text-sm font-medium text-gray-700 hover:text-gray-900"
              >
                Max Marks :{" "}
                <span> {item.maxMarks >= 0 ? item.maxMarks : "N/A"} </span>
              </button>
            </div>
            {showQuestions && (
              <div className="mt-4 rounded-lg border border-gray-200 bg-gray-50 p-4">
                <QuestionList
                  props={{
                    assignmentId: item._id,
                    ques: item.questions,
                    assignment: item,
                    // setAssignments,
                  }}
                />
              </div>
            )}
          </div>
        </div>
        <AssessedToggle props={{ assessed, setAssessed }} />

        <div className="space-y-1">
          {submissions.length > 0 &&
            submissions.map((submission) => (
              <SubmissionCard props={{ submission, setSubmissions }} />
            ))}
        </div>
      </div>

      {loading && <LoadingComp message={"Submissions loading "} />}
      {!loading && submissions.length === 0 && (
        <LoadingComp message={"No submission found ! "} loaded={true} />
      )}
    </div>
  );
};

export default AssignmentDetails;
